export const satelliteEs = {
  satellite: {
    title: "Imágenes Satelitales",
    subtitle: "Visualiza y analiza imágenes satelitales de tus parcelas",
    selectParcel: "Seleccionar Parcela",
    selectDate: "Seleccionar Fecha",
    indexType: "Tipo de Índice",
    ndvi: "NDVI - Salud Vegetativa",
    ndwi: "NDWI - Contenido de Agua",
    evi: "EVI - Vegetación Mejorada",
    savi: "SAVI - Ajustado al Suelo",
    ndre: "NDRE - Clorofila",
    downloadImage: "Descargar Imagen",
    compareImages: "Comparar Imágenes",
    cloudCoverage: "Cobertura de Nubes",
    resolution: "Resolución",
    acquisitionDate: "Fecha de Adquisición",
    noImagesAvailable: "No hay imágenes disponibles para esta fecha",
    loading: "Cargando imágenes satelitales..."
  },
  satellitePage: {
    title: "Análisis Satelital",
    subtitle: "Imágenes recientes de Copernicus Sentinel-2 (ciclo de revisita de 5 días) vía Sentinel Hub API",
    openeoQuota: "Cuota OpenEO",
    remaining: "restante",
    selectParcelAnalysis: "Seleccionar Parcela y Tipo de Análisis",
    selectParcel: "Seleccionar Parcela",
    analysisType: "Tipo de Análisis (Filtro)",
    changeFilterInfo: "Cambia el filtro de tipo de análisis para ver diferentes análisis satelitales aplicados a las imágenes",
    noParcelAvailable: "Sin Parcelas Disponibles",
    noParcelDesc: "Añade parcelas a tu cuenta para empezar a ver imágenes satelitales en tiempo real",
    goToParcels: "Ir al Gestor de Parcelas",
    sarTitle: "Análisis Radar SAR (Sentinel-1)",
    cloudFree: "Sin Nubes",
    sarDesc: "El Radar de Apertura Sintética funciona a través de nubes y de noche - ideal cuando la imagen óptica no está disponible",
    penetratesClouds: "Penetra nubes y funciona en todas las condiciones climáticas",
    detectsStructure: "Detecta estructura de cultivos, humedad del suelo y límites de campo",
    loadSar: "Cargar Análisis SAR",
    loadingSar: "Cargando SAR...",
    sarView: "Vista Radar SAR",
    sarDataSource: "Fuente de datos: Copernicus Sentinel-1 GRD (polarización VV/VH)",
    highResTitle: "¿Necesitas Imágenes de Mayor Resolución?",
    upgrade: "MEJORAR",
    cropValidation: "Validación de Cultivos",
    pkFertilization: "Fertilización P&K",
    cropValidationDesc: "Validación de cultivos con IA usando datos satelitales WorldCereal",
    pkFertilizationDesc: "Optimización inteligente de fósforo y potasio para tus cultivos",
    copernicusActive: "Copernicus Activo",
    updateData: "Actualizar Datos",
    noParcelsAvailable: "Sin Parcelas Disponibles",
    addParcelsToAccess: "Añade parcelas para acceder a capacidades avanzadas de análisis.",
    selectParcelPlaceholder: "Elige una parcela para ver imágenes satelitales",
    satelliteDataSource: "Fuente de Datos Satelitales",
    esaCopernicus: "ESA Copernicus Sentinel-2",
    resolution: "Resolución: 10m por píxel",
    updateFrequency: "Frecuencia: Cada 5 días",
    coverageGlobal: "Cobertura: Global",
    dataProcessing: "Procesamiento de Datos",
    cloudMaskingApplied: "Enmascaramiento de nubes aplicado",
    atmosphericCorrection: "Corrección atmosférica",
    realTimeAnalysis: "Análisis en tiempo real",
    applicationsSat: "Aplicaciones",
    cropHealthMonitoring: "Monitoreo de salud de cultivos",
    insuranceClaimValidation: "Validación de reclamaciones de seguro",
    yieldPredictionSat: "Predicción de rendimiento",
    lastSatellitePass: "Último paso satelital",
    nextUpdateLabel: "Próxima actualización",
    loadingSatelliteData: "Cargando datos satelitales...",
    successUpdate: "Datos satelitales actualizados correctamente",
    errorRefresh: "Error al actualizar datos satelitales",
    errorLoad: "Error al cargar datos satelitales",
    saveIndexPanelTitle: "Registro histórico {{index}}",
    saveIndexPanelWaiting: "Carga una imagen {{index}} real antes de guardar.",
    saveIndexPanelReady: "Imagen real cargada. Fecha de captura: {{date}}.",
    saveIndexButton: "Guardar registro {{index}}",
    saveIndexSaving: "Guardando…",
    saveIndexSuccessTitle: "Registro guardado",
    saveIndexSuccessDesc: "Registro {{index}} guardado para esta parcela.",
    saveIndexAlreadyTitle: "Ya estaba guardado",
    saveIndexAlreadyDesc: "El registro {{index}} ya estaba guardado para esta fecha.",
    saveIndexLoadImageTitle: "Carga la imagen primero",
    saveIndexLoadImageDesc: "Carga una imagen {{index}} real antes de guardar.",
    saveIndexErrorTitle: "No se pudo guardar el registro",
    saveIndexErrorDesc: "La imagen {{index}} se cargó, pero no se pudo guardar el registro histórico.",
    premiumImagery: {
      title: "¿Necesitas imágenes de mayor resolución?",
      badge: "SERVICIO PREMIUM",
      heading: "Imágenes satelitales premium bajo solicitud",
      body: "Sentinel Crop utiliza Sentinel-2 como capa estándar para la monitorización recurrente de parcelas. Para proyectos que requieren mayor nivel de detalle, puedes solicitar imágenes comerciales de alta resolución bajo demanda, desde 1,5 m hasta 30 cm, según disponibilidad, zona, resolución y tipo de adquisición.",
      bullet1: "Análisis detallado de subparcelas",
      bullet2: "Mejor identificación visual de variabilidad dentro del cultivo",
      bullet3: "Evidencia premium para informes, auditorías y seguros",
      bullet4: "Útil para pilotos, cooperativas y clientes enterprise",
      bullet5: "Disponible bajo solicitud con cobertura global",
      pricing: "Desde 199 € por solicitud",
      pricingNote: "Precio inicial orientativo para solicitudes básicas. El precio final depende de la resolución, superficie mínima, disponibilidad de archivo, nueva adquisición y condiciones de licencia.",
      cta: "Solicitar cotización premium",
      footer: "Servicio opcional bajo cotización. No incluye descarga automática de imagen desde la plataforma.",
      formTitle: "Solicitar cotización de imagen premium",
      formSubtitle: "Cuéntanos sobre tu proyecto. Nuestro equipo responderá con una cotización personalizada.",
      fieldName: "Nombre",
      fieldEmail: "Email",
      fieldCompany: "Empresa",
      fieldRegion: "País / región",
      fieldArea: "Superficie aproximada (ha)",
      fieldResolution: "Resolución deseada",
      fieldNeed: "Tipo de necesidad",
      fieldAcquisition: "Tipo de adquisición",
      fieldMessage: "Mensaje",
      resolution_15m: "1,5 m",
      resolution_50cm: "50 cm",
      resolution_30cm: "30 cm",
      resolution_unsure: "No estoy seguro",
      need_report: "Informe técnico",
      need_internal: "Imagen para uso interno",
      need_audit: "Auditoría o seguro",
      need_enterprise: "Proyecto enterprise",
      need_unsure: "No estoy seguro",
      acq_archive: "Archivo",
      acq_new: "Nueva adquisición",
      acq_unsure: "No estoy seguro",
      submit: "Enviar solicitud",
      submitting: "Enviando…",
      successTitle: "Solicitud enviada",
      successDesc: "Hemos recibido tu solicitud. Nuestro equipo responderá con una cotización personalizada.",
      errorTitle: "No se pudo enviar la solicitud",
      errorDesc: "Inténtalo de nuevo o escribe directamente a jose@sentinelcrop.com."
    }
  },
  splitViewPage: {
    title: "Comparación Vista Dividida",
    subtitle: "Compara imágenes satelitales de diferentes fechas lado a lado",
    selectParcel: "Seleccionar una parcela",
    selectParcelDesc: "Elige una parcela del desplegable de arriba para comparar imágenes satelitales.",
    loading: "Cargando Vista Dividida..."
  },
  splitView: {
    previous: "Anterior",
    next: "Siguiente",
    recentMonth: "Mes Reciente",
    olderMonth: "Mes Anterior",
    capturing: "Capturando...",
    capture12Months: "Capturar 12 meses",
    showDifferences: "Resaltar cambios",
    hideDifferences: "Ocultar cambios",
    generatingDifferences: "Calculando diferencias visuales...",
    differencesHint: "Las zonas resaltadas marcan cambios visuales relevantes entre ambos meses.",
    differencesUnavailable: "No se pudieron aislar diferencias claras con este par de imágenes.",
    differencesBadge: "Cambios",
    loading: "Cargando...",
    noSatelliteData: "Sin datos satelitales para este mes",
    previewNoData: "Preview — No real data",
    footerText: "Copernicus Sentinel-2 · Navegación mes a mes para ver la evolución temporal de la parcela",
    recent: "Reciente",
    older: "Anterior"
  },
  temporalComparison: {
    title: "Comparativa Temporal",
    currentMonth: "Mes Actual",
    previousMonth: "Mes Anterior",
    trend: "Tendencia",
    noData: "Sin datos",
    improvement: "Mejora",
    decline: "Disminución",
    stable: "Estable",
    analysis: "Análisis",
    significantImprovement: "✅ Mejora significativa en salud vegetal",
    declineDetected: "⚠️ Disminución detectada - revisar condiciones",
    stableConditions: "➡️ Condiciones estables"
  }
};
